import { render, staticRenderFns } from "./douyinBillboardGoodsItem.vue?vue&type=template&id=f68a3ee8&scoped=true"
import script from "./douyinBillboardGoodsItem.vue?vue&type=script&lang=js"
export * from "./douyinBillboardGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./douyinBillboardGoodsItem.vue?vue&type=style&index=0&id=f68a3ee8&prod&scoped=true&lang=css"
import style1 from "./douyinBillboardGoodsItem.vue?vue&type=style&index=1&id=f68a3ee8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68a3ee8",
  null
  
)

export default component.exports